import React from 'react';
import JuegoOnline from '../../components/juegoonline/JuegoOnline';
import styled from 'styled-components';

const FullHeightDiv = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 5px;
  box-sizing: border-box;

  & > * {
    max-width: 100vw;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
`;

const Section3 = () => {
  return (
    <FullHeightDiv>
       <JuegoOnline /> 
    </FullHeightDiv>
  );
};

export default Section3;
